import { useContext, useEffect, useState } from "react";
import { LocaleContext } from "../../routing/LangRouter";
import { Grid } from "@mui/material";
import SearchFormContent from "../../components/view/bus/search-form-content";

export default function BusSearchForm() {
    const { locale } = useContext(LocaleContext);
    const [uid, setUid] = useState();
    const [requestFlag, setRequestFlag] = useState(false);

    useEffect(() => {
        const updatedInfo = {
            isTicket: false,
            isAccommodation: false,
            isItinerary: false,
            isHotelInternational: false,
            isBus: true,
        };

        sessionStorage.setItem("generalInformation", JSON.stringify(updatedInfo));
    }, []);

    return (
        <Grid className="bus" container>
            <Grid className="hotel__form" container item xs={12} rowGap={2.5} justifyContent={{ xs: "space-between", md: "flex-start" }}>
                <SearchFormContent setRequestFlag={setRequestFlag} setUid={setUid} busRoute={`/${locale}/bus`} />
            </Grid>
        </Grid>
    );
}
